import React, { useMemo, useCallback } from "react"
import { useDispatch } from "react-redux"
import { goBack } from "react-router-redux"
import { Button, Icon, Stack, Typography } from "@mui/material"
import { makeStyles } from "@mui/styles"
import CalendarToday from "@mui/icons-material/CalendarToday"
import moment from "moment"

import { COLORS } from "../../utils"
import GenericTopBarHeader from "../../components/GenericTopBarHeader"

const ProdPlannerHeader = ({
  pathname = "",
  selectedDate,
  selectedKitchenArea,
  onCancel = null,
  onSave = null,
  onCooling = null,
  showCoolingButton = true,
  coolingDisabled = false,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const subtitle = useMemo(() => {
    const formattedProductionDay = moment.utc(selectedDate).format("DD/MM/YYYY")
    const kitchenAreaName = selectedKitchenArea?.name || ""
    return kitchenAreaName ? `/ ${kitchenAreaName} - ${formattedProductionDay}` : `/ ${formattedProductionDay}`
  }, [selectedKitchenArea, selectedDate])

  const isViewPage = useMemo(() => pathname.includes("view"), [pathname])

  const onBack = useCallback(() => {
    dispatch(goBack())
  }, [dispatch])

  const _renderRightAction = useCallback(() => {
    if (!isViewPage) return null

    return (
      <Stack direction="row" spacing={2}>
        {showCoolingButton && (
          <Button
            variant="outlined"
            onClick={onCooling}
            disabled={coolingDisabled}
            sx={{
              textTransform: "none",
              color: COLORS.PRIMARY_BLUE_500,
              borderColor: COLORS.PRIMARY_BLUE_500,
              "&:hover": {
                borderColor: COLORS.PRIMARY_BLUE_500,
                backgroundColor: "rgba(0, 102, 204, 0.04)"
              }
            }}
          >
            Générer cellules refroidissement
          </Button>
        )}
        {onCancel && (
          <Button
            variant="outlined"
            onClick={onCancel}
            sx={{
              textTransform: "none",
              color: COLORS.PRIMARY_BLUE_500,
              borderColor: COLORS.PRIMARY_BLUE_500,
              "&:hover": {
                borderColor: COLORS.PRIMARY_BLUE_500,
                backgroundColor: "rgba(0, 102, 204, 0.04)"
              }
            }}
          >
            Annuler
          </Button>
        )}
        {onSave && (
          <Button
            variant="contained"
            color="primary"
            onClick={onSave}
            sx={{
              textTransform: "none",
              backgroundColor: COLORS.PRIMARY_BLUE_500,
              "&:hover": {
                backgroundColor: COLORS.PRIMARY_BLUE_600
              }
            }}
          >
            Enregistrer
          </Button>
        )}
      </Stack>
    )
  }, [isViewPage, onCancel, onSave, onCooling])

  return (
    <div className={classes.headerBlock}>
      <GenericTopBarHeader
        title={(
          <div className={classes.headerTitle}>
            <Icon className={classes.headerIcon}>
              <CalendarToday />
            </Icon>
            <Typography variant="h7" sx={{ fontWeight: 500, color: COLORS.PRIMARY_BLUE_500 }}>
              Plan de prod
            </Typography>
          </div>
        )}
        info={
          <p className={classes.headerSubtitle}>
            {subtitle}
          </p>
        }
        rightAction={_renderRightAction()}
        {...isViewPage && { onBack }}
        className={classes.header}
      />
    </div>
  )
}

export default ProdPlannerHeader


const useStyles = makeStyles({
  headerBlock: {
    width: "100%"
  },
  header: {
    width: "100%"
  },
  headerTitle: {
    display: "flex",
    fontSize: "16px",
    lineHeight: "16px",
    gap: "8px",
    justifyContent: "center",
    alignItems: "center",
    color: COLORS.PRIMARY_BLUE_500
  },
  headerIcon: {
    color: COLORS.PRIMARY_BLUE_500,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      fontSize: "24px",
      padding: "2px 1px"
    }
  },
  headerSubtitle: {
    paddingLeft: 8,
    fontSize: "16px",
    color: COLORS.DRAFT_GREY
  }
})
